<template>
  <div class="common-page realtime-management">
    <div class="tab-check-box">
      <custom-tab-box
        :tab-data="tabData"
        :selectTab="selectTab"
        @change="handleChange"
      ></custom-tab-box>
    </div>
    <div class="table-content">
      <driver-report-info v-if="selectTab === 1"></driver-report-info>
      <driver-dispatch-info v-if="selectTab === 2"></driver-dispatch-info>
    </div>
  </div>
</template>

<script>
import driverReportInfo from "./components/driverReportInfo.vue";
import driverDispatchInfo from "./components/driverDispatchInfo.vue";
import vehicleStorageSpace from "./components/vehicleStorageSpace.vue";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
export default {
  name: "Realtime-management",
  components: {
    CustomTabBox,
    driverReportInfo,
    vehicleStorageSpace,
    driverDispatchInfo,
  },
  data() {
    return {
      selectTab: 1,
      tabData: [
        {
          label: 1,
          value: "司机实时上报信息",
        },
        {
          label: 2,
          value: "司机实时承运状态",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleChange(val) {
      this.selectTab = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.realtime-management {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .table-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .tab-check-box {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem;
    box-sizing: border-box;
  }
}
</style>
